import React from "react";
// import CV from "../../assets/AmartyaKumar-resume.pdf";

const CTA = () => {
  return (
    <div className="cta">
      <a href="#home" download className="btn">
        Download CV
      </a>
    </div>
  );
};

export default CTA;
